import { CdkColumnDef } from '@angular/cdk/table';
import {
  Component,
  ElementRef,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { OverlapService } from 'src/app/shared/service/overlapService/overlap.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
import { RemarksPopupComponent } from '../remarks-popup/remarks-popup.component';
import { ExportFilePopupComponent } from 'src/app/shared/components/export-file-popup/export-file-popup.component';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';

@Component({
  selector: 'app-end-voyage-reports',
  templateUrl: './end-voyage-reports.component.html',
  styleUrls: ['./end-voyage-reports.component.scss'],
})
export class EndVoyageReportsComponent {
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('table', { static: false }) table!: ElementRef;
  elements: any;
  paginatedData: any[] = [];
  itemsPerPage: number = 100;
  currentPage: number = 1;
  rowData: any;
  graph: boolean = false;
  counter = 1;
  conditionOptions = ['Ballast', 'Laden'];
  filteredData: any;
  visible: boolean = false;
  formattedSegment: any;
  save: boolean = false;
  commentsData: any;
  userList = [
    { label: 'SAKA - Satish', value: 'SAKA' },
    { label: 'SABA - Sandokan', value: 'SABA' },
    { label: 'ROAK - Roman', value: 'ROAK' },
    { label: 'AAHA - Ahmet', value: 'AAHA' },
    { label: 'NIAL - Nikita', value: 'NIAL' },
    // { label: 'JESH - Jeet', value: 'JESH' },
    { label: 'RAPA - Rahul', value: 'RAPA' },
    { label: 'AHKM - Abhishek', value: 'AHKM' },
    { label: 'SAMH - Sadique Muhammad', value: 'SAMH' },
    { label: 'ALYI - Alex', value: 'ALYI' },
  ];
  username: any;
  length: any;
  subusername: any;
  isLoadingTable: boolean = false;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private fb: FormBuilder,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private overlayService: OverlapService,
    private dialog: MatDialog,
    private prequestFormService: PortRequestFormServiceService,
  ) {
    this.filterForm = this.fb.group({
      from_date: ['', [Validators.required]],
      to_date: ['', [Validators.required]],
      condition: ['', [Validators.required]],
      voyNumber: [''],
    });
  }
  ngOnInit() {
    this.loadDummyData();
    this.username = localStorage.getItem('username');
    this.subusername = localStorage.getItem('loginPic') ?? '';
    this.sharedDataService.rowData$.subscribe((rowData) => {
      this.rowData = rowData;
      if (this.rowData) {
        localStorage.setItem('shipName', this.rowData.original_vessel_name);
        localStorage.setItem('segment', this.rowData.segment);
        localStorage.setItem('vessel_status', this.rowData.vessel_status);
      }
    });
    if (this.username !== 'Eiger Shipping') {
      this.loadData();
    }
    this.getCommenta();
  }
  loadDummyData() {
    this.elements = [
      {
        sNo: 1,
        evrLink: '',
        shipName: 'Vessel1',
        imoNumber: '12345',
        segment: 'MR',
        voyNumber: '1023',
        condition: 'LADEN',
        from: 'SINGAPORE',
        to: 'FUJAIRAH',
        fromDate: '01-01-2025 10:00',
        toDate: '08-01-2025 12:00',
        instructedSpd: 12.5,
        cpConsumption: 25.4,
        goodWxPerSpd: '13.20',
        voyAvgSpd: '12.90',
        goodWxDailyConsp: { HSFO: '10.50', VLSFO: '2.10', GO: '0.80' },
        goodWxPer: '85.2',
        goodWxDist: 850,
        voyDuration: 140,
        voyDistance: 1200,
        totalBunkerConsumption: 60,
        averageDialyCon: '24.30',
        timeLost: -2.5,
        bunkerLostOrGain: { HSFO: -1.2, VLSFO: 0.8, GO: 0.0 },
        claimEst: { hire: 12000, bunkPrice: 650 },
        claimable_amout: 0,
        claimable: 'Yes',
        voyag_id: 'V001',
      },
      {
        sNo: 2,
        evrLink: '',
        shipName: 'Vessel2',
        imoNumber: '12365',
        segment: 'LR1',
        voyNumber: '2045',
        condition: 'BALLAST',
        from: 'DUBAI',
        to: 'MUMBAI',
        fromDate: '10-01-2025 05:00',
        toDate: '15-01-2025 18:00',
        instructedSpd: 13.0,
        cpConsumption: 26.2,
        goodWxPerSpd: '13.90',
        voyAvgSpd: '13.50',
        goodWxDailyConsp: { HSFO: '9.20', VLSFO: '3.10', GO: '1.20' },
        goodWxPer: '90.1',
        goodWxDist: 900,
        voyDuration: 120,
        voyDistance: 1100,
        totalBunkerConsumption: 58,
        averageDialyCon: '23.80',
        timeLost: 1.8,
        bunkerLostOrGain: { HSFO: 1.4, VLSFO: -0.5, GO: 0.3 },
        claimEst: { hire: 15000, bunkPrice: 700 },
        claimable_amout: 0,
        claimable: 'No',
        voyag_id: 'V002',
      },
    ];

    this.length = 2;
    this.paginateData();
  }

  toggleMapView() {
    this.graph = !this.graph;

    if (this.graph) {
      this.router.navigate(['/vp-performanceGraph']);
    } else {
      this.router.navigate(['/tableView']);
    }
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
  formatSegment(segment: string | null) {
    if (!segment) return '';
    return segment.charAt(0).toUpperCase() + segment.slice(1).toLowerCase();
  }
  getMaskedVesselName(imo: string | number, vesselName: string): string {
    if (this.subusername?.toLowerCase() === 'demo') {
      return String(imo) === '9399480' ? 'Vessel 1' : 'Vessel 2';
    }

    return (
      vesselName
        ?.toLowerCase()
        .split(' ')
        .filter(Boolean)
        .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ') || 'NA'
    );
  }
  getMaskedImo(imo: string | number): string {
    if (this.subusername?.toLowerCase() === 'demo') {
      return 'xxxxxxx';
    }

    return String(imo || '__');
  }
  loadData() {
    this.isLoadingTable = true;
    const from_date_str = this.filterForm.get('from_date')?.value || '';
    const to_date_str = this.filterForm.get('to_date')?.value || '';
    const condition = this.filterForm.get('condition')?.value || '';
    const voyNumber = this.filterForm.get('voyNumber')?.value || '';
    const storedShipName = localStorage.getItem('shipName')?.toUpperCase();
    const storedSegment = localStorage.getItem('segment');
    const page = this.currentPage;
    const storedVesselStatus = localStorage.getItem('vessel_status');
    if (
      storedSegment !== 'LR1' &&
      storedSegment !== 'MR' &&
      storedSegment !== 'LPG' &&
      storedSegment !== 'LR2'
    ) {
      this.formattedSegment = this.formatSegment(storedSegment);
    } else {
      this.formattedSegment = storedSegment;
    }

    this.sharedDataService
      .getVesselView(
        storedShipName,
        this.formattedSegment,
        storedVesselStatus,
        from_date_str,
        to_date_str,
        condition,
        voyNumber,
        page,
      )
      .subscribe((data) => {
        this.length = data.total_records;
        let filterData = data.fleet_data;
        const clientFilters: { [key: string]: (item: any) => boolean } = {
          'Eiger Shipping': (item) => item.client_name === 'Client',
          'Zeronorth ZN': (item) => item.client_name === 'ZeroNorth',
          'Elite Shipping': (item) =>
            item.client_name === 'Elite' ||
            item.client_name === 'ELITE TANKSHIP DMCC',
          'Bunge Shipping': (item) => item.client_name === 'Bunge',
          'Alcor Shipping': (item) =>
            item.client_name === 'ALCOR CHARTERING DMCC',
          'EMZoil Shipping': (item) =>
            item.client_name === 'EMZ OIL' ||
            item.client_name === 'EMZOIL FZCO' ||
            (item.client_name || '').toLowerCase().includes('emz'),
        };
        if (this.username === 'Meraki - Operations') {
          filterData = filterData;
        } else if (clientFilters[this.username]) {
          filterData = filterData.filter(clientFilters[this.username]);
        }

        this.elements = filterData.map((item: any, index: number) => ({
          sNo: index + 1,
          evrLink: item.evrLink,

          // Mask vessel name for demo
          shipName: this.getMaskedVesselName(item.vessel_id, item.shipName),

          // Mask IMO for demo
          imoNumber: this.getMaskedImo(item.vessel_id),

          segment: item.segment,
          voyNumber: item.voyNumber === 0 ? '__' : item.voyNumber,
          condition: item.condition.toUpperCase(),
          from: item.from.toUpperCase(),
          fromDate: item.fromDate,
          to: item.to.toUpperCase(),
          toDate: item.toDate,
          instructedSpd: item.instructedSpd,
          cpConsumption: item.cpConsumption,

          goodWxPerSpd: item.goodWxPerSpd.toFixed(2),
          voyAvgSpd: item.voyAvgSpd.toFixed(2),

          goodWxDailyConsp: {
            HSFO:
              item.goodWxDailyConsp.hsfo !== 0
                ? item.goodWxDailyConsp.hsfo.toFixed(2)
                : '__',

            VLSFO:
              item.goodWxDailyConsp.vlsfo !== 0
                ? item.goodWxDailyConsp.vlsfo.toFixed(2)
                : '__',

            GO:
              item.goodWxDailyConsp.go !== 0
                ? item.goodWxDailyConsp.go.toFixed(2)
                : '__',
          },

          goodWxPer: (item.goodWxPer * 100).toFixed(1),
          goodWxDist: item.goodWxDist,
          voyDuration: item.voyDuration,
          voyDistance: item.voyDistance,
          totalBunkerConsumption: item.totalBunkerConsumption,

          averageDialyCon: item.averageDialyCon.toFixed(2),
          timeLost: item.timeLostGain.toFixed(1),

          bunkerLostOrGain: {
            HSFO:
              item.bunkerLostOrGain.hsfo !== 0
                ? item.bunkerLostOrGain.hsfo.toFixed(2)
                : '__',

            VLSFO:
              item.bunkerLostOrGain.vlsfo !== 0
                ? item.bunkerLostOrGain.vlsfo.toFixed(2)
                : '__',

            GO:
              item.bunkerLostOrGain.go !== 0
                ? item.bunkerLostOrGain.go.toFixed(2)
                : '__',
          },

          claimEst: {
            hire: item.claimEst.hire,
            bunkPrice: item.claimEst.bunkPrice,
          },

          claimable_amout: item.claimable_amout,
          claimable: item.claimable !== 0 ? item.claimable : 'N/A',
          voyag_id: item.voyag_id,
        }));
        this.paginateData();
        this.isLoadingTable = false;
      },
    );
  }
  getVesselNameColor(totalFuelLg: number): string {
    return totalFuelLg < 0 ? 'red' : '';
  }
isFilterOpen: boolean = false;
  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.paginatedData = this.elements?.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }
  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.loadData();
  }

  sortData(sort: Sort) {
    const data = this.elements.slice();
    if (!sort.active || sort.direction === '') {
      this.elements = data;
      return;
    }

    this.elements = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, isAsc, sort.active);
    });
  }

  compare(a: any, b: any, isAsc: boolean, column: string) {
    let valueA = this.getNestedValue(a, column);
    let valueB = this.getNestedValue(b, column);

    if (valueA === null || valueA === undefined) return isAsc ? -1 : 1;
    if (valueB === null || valueB === undefined) return isAsc ? 1 : -1;

    const numericalColumns = ['timeLost', 'hsfo', 'vlsfo', 'go'];
    if (numericalColumns.includes(column)) {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getNestedValue(obj: any, column: string) {
    switch (column) {
      case 'hsfo':
      case 'vlsfo':
      case 'go':
        return obj.bunkerLostOrGain[column.toUpperCase()];
      default:
        return obj[column];
    }
  }

  showDetails(row: any) {
    this.router.navigate(['/vp-shipView']);
  }

  downloadIcon(row: any) {
    const baseUrl: string = window.location.origin;
    const pdf = row.evrLink;
    if (pdf) {
      const fullUrl = baseUrl + pdf;
      this.toastr.success(ToasterMessages.PdfProcessing);
      fetch(fullUrl)
        .then((response) => response.blob())
        .then((blob) => {
          this.overlayService.showPdf(blob);
          this.toastr.clear();
        })
        .catch((error) => {
          console.error('Error fetching PDF data:', error);
        });
    } else {
      this.toastr.success(ToasterMessages.RecordNotFount);
    }
  }
  backClick() {
    this.router.navigate(['/vp-CharterpartyTable']);
  }
  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }
  exitEdit(row: any) {
    const claimEst = row.claimEst;
    if (claimEst.hire || claimEst.bunkPrice) {
      this.save = true;
      const claimableAmount = this.calculateClaimableAmount(row);
      let payload = {
        daily_hire: claimEst.hire,
        avg_bunker_price: claimEst.bunkPrice,
        claimable_amout: claimableAmount,
        voyage_id: row.voyag_id,
      };
      if (claimEst.hire && claimEst.bunkPrice) {
        this.sharedDataService
          .postClaimEstimate(payload)
          .subscribe((data) => {});
      }
    }
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  saveClick() {
    this.paginatedData = [];
    this.loadData();
    this.save = false;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
        bunkPrice * (VLSFO || 0) +
        bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;
    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }

  clearClick() {
    this.filterForm.reset();
    this.loadData();
    
  }

  filterClick() {
    this.loadData();
    
    // const from_date_str = this.filterForm.get('from_date')?.value;
    // const to_date_str = this.filterForm.get('to_date')?.value;
    // const condition = this.filterForm.get('condition')?.value;
    // const voyNumber = this.filterForm.get('voyNumber')?.value;
    // if ((from_date_str && !to_date_str) || (!from_date_str && to_date_str)) {
    //   console.warn('Please select both from and to dates.');
    //   return;
    // }
    // const formatDateToYYYYMMDD = (dateString: string | null) => {
    //   if (dateString) {
    //     const date = new Date(dateString);
    //     const year = date.getFullYear();
    //     const month = String(date.getMonth() + 1).padStart(2, '0');
    //     const day = String(date.getDate()).padStart(2, '0');
    //     return `${year}-${month}-${day}`;
    //   }
    //   return null;
    // };

    // const from_date = formatDateToYYYYMMDD(from_date_str);
    // const to_date = formatDateToYYYYMMDD(to_date_str);

    // const filteredData = this.elements.filter((element: any) => {
    //   const elementFromDate = element.fromDate
    //     ? formatDateToYYYYMMDD(element.fromDate)
    //     : null;

    //   return (
    //     (!from_date || (elementFromDate && elementFromDate >= from_date)) &&
    //     (!to_date || (elementFromDate && elementFromDate <= to_date)) &&
    //     (!condition ||
    //       element.condition?.toLowerCase() === condition.toLowerCase()) &&
    //     (!voyNumber || Number(element.voyNumber) === Number(voyNumber))
    //   );
    // });

    // this.filteredData = filteredData;
    // this.paginatedData = filteredData.slice(0, this.itemsPerPage);
    // this.currentPage = 0;
  }
  // exportClick() {
  //   const data = this.filteredData || this.elements;
  //   const firstItem = data[0];
  //   const shipName = firstItem.shipName || 'UnknownShip';
  //   const segment = firstItem.segment || 'UnknownSegment';
  //   const csvHeader =
  //     'Ship Name,Segment,Voy Number,condition,From,To,COSP,EOSP,Instructed Speed,Cp Consumption,Good Wx Performance Speed,Voy Avg Speed,Good Wx HSFO,Good Wx VLSFO,Good Wx GO,Good Wx %,Good Wx Distance,Voy Duration,Voy Distance,Total Bunker consumption,Avg Daily Consumption,Time Lost (or) Gain,HSFO,VLSFO,GO,Daily Hire,Avg Bunker Price,Claimable Amount';
  //   const csvData = data
  //     .map((item: any) => {
  //       const bunkLostGain = item.bunkerLostOrGain
  //         ? `${item.bunkerLostOrGain.HSFO},${item.bunkerLostOrGain.VLSFO},${item.bunkerLostOrGain.GO}`
  //         : ',,';
  //       const goodWxDailyConsp = item.goodWxDailyConsp
  //         ? `${item.goodWxDailyConsp.HSFO},${item.goodWxDailyConsp.VLSFO},${item.goodWxDailyConsp.GO}`
  //         : ',,';
  //       const claimEst = item.claimEst
  //         ? `${item.claimEst.hire},${item.claimEst.bunkPrice}`
  //         : ',';
  //       const goodWxPer = Number(item.goodWxPer).toFixed(1);
  //       return `${item.shipName},${item.segment},${item.voyNumber},${
  //         item.condition
  //       },${item.from},${item.to},${item.fromDate},${item.toDate},${
  //         item.instructedSpd
  //       },${item.cpConsumption},${item.goodWxPerSpd},${
  //         item.voyAvgSpd
  //       },${goodWxDailyConsp},${goodWxPer},${item.goodWxDist},${
  //         item.voyDuration
  //       },${item.voyDistance},${item.totalBunkerConsumption},${
  //         item.averageDialyCon
  //       },${
  //         item.timeLost
  //       },${bunkLostGain},${claimEst},${this.calculateClaimableAmount(item)}`;
  //     })
  //     .join('\n');
  //   const csvContent = `${csvHeader}\n${csvData}`;
  //   const blob = new Blob([csvContent], { type: 'text/csv' });
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.href = url;
  //   a.download = `${shipName}_${segment}.csv`;
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // }
  exportClick() {
    const dialogRef = this.dialog.open(ExportFilePopupComponent, {
      width: '420px',
      height: 'auto',
      disableClose: true,
      panelClass: 'export-popup-container',
    });

    dialogRef.afterClosed().subscribe((selectedReportType) => {
      if (!selectedReportType) return;

      const source =
        selectedReportType === 'speedConsumption'
          ? 'SNC'
          : selectedReportType === 'portConsumption'
            ? 'PC'
            : 'ALL';
      const imo = this.elements[0].imoNumber;
      this.prequestFormService.getCombinedExcelData(source, imo).subscribe({
        next: (rawTextResponse: string) => {
          let parsedResponse: any;

          try {
            const safeJsonString = rawTextResponse.replace(/:NaN/g, ':null');
            parsedResponse = JSON.parse(safeJsonString);
          } catch (e) {
            this.toastr.error(ToasterMessages.Error);
            return;
          }

          const apiData = parsedResponse.data || [];
          if (!apiData.length) {
            this.toastr.warning('No data returned for export.');
            return;
          }

          const headers = [
            'S.No',
            'Ship Name',
            'IMO No',
            'Start Port',
            'End Port',
            'Start Date',
            'End Date',
            'C/P Loss/Gain HSFO',
            'C/P Loss/Gain VLSFO',
            'C/P Loss/Gain LSMGO',
            'Technical Loss/Gain HSFO',
            'Technical Loss/Gain VLSFO',
            'Technical Loss/Gain LSMGO',
            'Total Time Gain',
            'Total Time Loss',
            'Source',
          ];

          const rows = apiData.map((el: any, index: number) => [
            index + 1,
            el.vessel_name || '',
            el.vessel_imo || '',
            el.start_port || '',
            el.end_port || '',
            el.start_date ? new Date(el.start_date).toLocaleString() : '',
            el.end_date ? new Date(el.end_date).toLocaleString() : '',
            el.cp_warrantedloss_or_gain_mt__hsfo?.toFixed(2) || '0.00',
            el.cp_warrantedloss_or_gain_mt__vlsfo?.toFixed(2) || '0.00',
            el.cp_warrantedloss_or_gain_mt__lsgo?.toFixed(2) || '0.00',
            el.technical_designloss_or_gain_mt_hsfo?.toFixed(2) || '0.00',
            el.technical_designloss_or_gain_mt_vlsfo?.toFixed(2) || '0.00',
            el.technical_designloss_or_gain_mt_lsgo?.toFixed(2) || '0.00',
            el.total_time_gain === null || isNaN(el.total_time_gain)
              ? ''
              : el.total_time_gain.toString(),
            el.total_time_loss === null || isNaN(el.total_time_loss)
              ? ''
              : el.total_time_loss.toString(),
            el.source || '',
          ]);

          const csvContent = [headers, ...rows]
            .map((row) =>
              row
                .map((field: any) => {
                  const strField =
                    field !== undefined && field !== null ? String(field) : '';
                  return `"${strField.replace(/"/g, '""')}"`;
                })
                .join(','),
            )
            .join('\n');

          const blob = new Blob([csvContent], {
            type: 'text/csv;charset=utf-8;',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `Vessel_View_Export_${new Date().toISOString().slice(0, 10)}.csv`;

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        },
        error: (err: any) => {
          console.error('Error while exporting report:', err);
          alert('An API error occurred. Please check the network console.');
        },
      });
    });
  }

  printTable() {
    const dataToPrint = this.filteredData || this.elements;

    // Generate the HTML content for the table
    const tableHtml = `
      <html>
        <head>
          <style>
            .tableTitle {
              display: block;
              position: fixed; 
              top: 0px !important;
              left: 10px !important;
              width: 100%;
              font-size: 1.2em;
              margin-bottom: 10px; 
              color: #766b6b;
              font-family: "Poppins", sans-serif;
              page-break-before: avoid;
            }
            .printable-table {
              position: absolute;
              max-height: 100%;
              top: 50px;
              page-break-inside: avoid;
                overflow: hidden; 
            }
            .filter {
              display: none;
            }
            * {
              -webkit-print-color-adjust: exact !important;
              print-color-adjust: exact !important;
            }
            @page {
              size: A4;
              margin: 0; /* Remove margins */
            }
            table {
             width: 100%;
             border-collapse: collapse;
             margin-bottom: 20px;
            }

            th, td {
                font-size: 7px;
            }
            th {
              background-color: #0a4380d9;
              color: white;
              border: 1px solid #8d8e8f;
            }
            td {
              color: #766b6b;
              white-space: nowrap;
              padding: 8px;
            }
            tr:nth-child(even) {
              background-color: #cbeaf0;
            }
            tr:nth-child(odd) {
              background-color: #f5fdff;
            }
            .logo {
              position: absolute;
              top: 0px;
              right: 10px;
              width: 65px;
            }
          </style>
        </head>
        <body>
          <img src="../../../assets/images/logo.png" class="logo" />
          <h2 class="tableTitle">Vessel View Table</h2>
          <table class="printable-table">
            <thead>
              <tr>
                <th rowspan="2">S.No</th>
                <th rowspan="2">Ship</th>
                <th rowspan="2">I.M.O Number</th>
                <th rowspan="2">Segment</th>
                <th rowspan="2">Voy Number</th>
                <th rowspan="2">Condition</th>
                <th colspan="4">Ports</th>
                <th rowspan="2">Instructed Speed (kts)</th>
                <th rowspan="2">CP Consumption (mt/day)</th>
                <th rowspan="2">Good Wx Performance Speed (kts)</th>
                <th rowspan="2">Voyage Average Speed (kts)</th>
                <th colspan="3">Good Wx Daily Consumption (mt/day)</th>
                <th rowspan="2">Good Wx %</th>
                <th rowspan="2">Good Wx Dist (nm)</th>
                <th rowspan="2">Voyage Duration (Hours)</th>
                <th rowspan="2">Voyage Distance (nm)</th>
                <th rowspan="2">Total Bunker Consumption (mt/day)</th>
                <th rowspan="2">Average Daily Consumption (mt/day)</th>
                <th rowspan="2">Time Lost(-) or Gained(+)</th>
                <th colspan="3">Bunker Lost(-) or Gained(mt)</th>
              </tr>
              <tr>
                <th>From</th>
                <th>To</th>
                <th>COSP (Date & UTC time)</th>
                <th>EOSP (Date & UTC time)</th>
                <th>HSFO</th>
                <th>VLSFO</th>
                <th>GO</th>
                 <th>HSFO</th>
                <th>VLSFO</th>
                <th>GO</th>
              </tr>
            </thead>
            <tbody>
              ${dataToPrint
                .map(
                  (item: any, index: number) => `
                  <tr>
                    <td>${index + 1}</td>
                    <td>${item.shipName}</td>
                    <td>${item.imoNumber}</td>
                    <td>${item.segment}</td>
                    <td>${item.voyNumber}</td>
                    <td>${item.condition}</td>
                    <td>${item.from}</td>
                    <td>${item.to}</td>
                    <td>${item.fromDate}</td>
                    <td>${item.toDate}</td>
                    <td>${item.instructedSpd}</td>
                    <td>${item.cpConsumption}</td>
                    <td>${item.goodWxPerSpd}</td>
                    <td>${item.voyAvgSpd}</td>
                    <td>${item.goodWxDailyConsp.HSFO}</td>
                    <td>${item.goodWxDailyConsp.VLSFO}</td>
                    <td>${item.goodWxDailyConsp.GO}</td>
                    <td>${item.goodWxPer}%</td>
                    <td>${item.goodWxDist}</td>
                    <td>${item.voyDuration}</td>
                    <td>${item.voyDistance}</td>
                    <td>${item.totalBunkerConsumption}</td>
                    <td>${item.averageDialyCon}</td>
                    <td style="color: ${
                      item.timeLost < 0
                        ? 'red'
                        : item.timeLost > 0
                          ? 'green'
                          : 'inherit'
                    }">${item.timeLost}</td>
                    <td style="color: ${
                      item.bunkerLostOrGain.HSFO < 0
                        ? 'red'
                        : item.bunkerLostOrGain.HSFO > 0
                          ? 'green'
                          : 'inherit'
                    }">${item.bunkerLostOrGain.HSFO}</td>
                    <td style="color: ${
                      item.bunkerLostOrGain.VLSFO < 0
                        ? 'red'
                        : item.bunkerLostOrGain.VLSFO > 0
                          ? 'green'
                          : 'inherit'
                    }">${item.bunkerLostOrGain.VLSFO}</td>
                    <td style="color: ${
                      item.bunkerLostOrGain.GO < 0
                        ? 'red'
                        : item.bunkerLostOrGain.GO > 0
                          ? 'green'
                          : 'inherit'
                    }">${item.bunkerLostOrGain.GO}</td>
                  </tr>
                `,
                )
                .join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Create a new iframe element for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDocument) {
      iframeDocument.open();
      iframeDocument.write(tableHtml);
      iframeDocument.close();

      // Trigger print
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }
  }

  downloadClick() {
    const from_date = this.filterForm.get('from_date')?.value;
    const to_date = this.filterForm.get('to_date')?.value;
    const condition = this.filterForm.get('condition')?.value;
    const storedShipName = localStorage.getItem('shipName');
    const storedSegment = localStorage.getItem('segment');

    this.toastr.success(ToasterMessages.UnderDev);
  }

  openRemarks(row: any) {
    localStorage.setItem('remarksId', row.voyag_id);
    const dialog = this.dialog.open(RemarksPopupComponent, {
      width: '760px',
      height: '560',
      disableClose: true,
    });
  }
  // getFirstCommentTooltip(voyageId: string): string {
  //   const voyage = this.commentsData.find(
  //     (item: any) => item.voyage_id === voyageId
  //   );
  //   if (voyage && voyage.comments.length > 0) {
  //     const first = voyage.comments[0];
  //     const localTime = this.parseLocalDate(first.timestamp);
  //     const utcTime = localTime ? this.formatUTC(localTime) : first.timestamp;
  //     return `${this.getUserName(first.pic)}\n🕒${utcTime}\n💬 ${
  //       first.comment
  //     }`;
  //   }
  //   return 'No comment available';
  // }
  getFirstCommentTooltip(voyageId: string): string {
    if (!this.commentsData || !Array.isArray(this.commentsData)) {
      return 'No comment available';
    }

    const voyage = this.commentsData.find(
      (item: any) => item.voyage_id === voyageId,
    );

    if (voyage?.comments?.length > 0) {
      const first = voyage.comments[0];
      const localTime = this.parseLocalDate(first.timestamp);
      const utcTime = localTime ? this.formatUTC(localTime) : first.timestamp;

      return `${this.getUserName(first.pic)}\n🕒${utcTime}\n💬 ${first.comment}`;
    }

    return 'No comment available';
  }

  parseLocalDate(dateStr: string): Date | null {
    try {
      const [datePart, timePart] = dateStr.split(', ');
      const [yy, MM, dd] = datePart.split('/').map(Number);
      const year = 2000 + yy; // assuming year 20yy
      const [time, modifier] = timePart.split(' ');
      let [hours, minutes] = time.split(':').map(Number);

      if (modifier === 'PM' && hours < 12) {
        hours += 12;
      } else if (modifier === 'AM' && hours === 12) {
        hours = 0;
      }

      return new Date(year, MM - 1, dd, hours, minutes);
    } catch (e) {
      console.error('Error parsing date:', e);
      return null;
    }
  }

  formatUTC(date: Date): string {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes} UTC`;
  }

  getUserName(code: string): string {
    const user = this.userList.find((u) => u.value === code);
    if (user && user.label.includes(' - ')) {
      return user.label.split(' - ')[1]; // Get only the name part
    }
    return code; // fallback
  }
  getCommenta() {
    this.sharedDataService.getAllComments().subscribe((data) => {
      this.commentsData = data;
    });
  }
}
